import React from "react";
import Masonry from "react-masonry-component";
import { createGlobalStyle } from "styled-components";
import AOS from "aos";
AOS.init();

const GlobalStyles = createGlobalStyle`
    body.hide{
          overflow-y: hidden; /* Hide vertical scrollbar */
          overflow-x: hidden; /* Hide horizontal scrollbar */
        }
`;

const Gallery = function () {
  /* lightbox1 */
  const [lighbx, setlighbx] = React.useState(false);
  const handleBtnClick = (): void => {
    setlighbx(!lighbx);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose = (): void => {
    setlighbx(!lighbx);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  /* lightbox2 */
  const [lighbx1, setlighbx1] = React.useState(false);
  const handleBtnClick1 = (): void => {
    setlighbx1(!lighbx1);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose1 = (): void => {
    setlighbx1(!lighbx1);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  /* lightbox2 */
  const [lighbx2, setlighbx2] = React.useState(false);
  const handleBtnClick2 = (): void => {
    setlighbx2(!lighbx2);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose2 = (): void => {
    setlighbx2(!lighbx2);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  const [lighbx3, setlighbx3] = React.useState(false);
  const handleBtnClick3 = (): void => {
    setlighbx3(!lighbx3);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose3 = (): void => {
    setlighbx3(!lighbx3);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  const [lighbx4, setlighbx4] = React.useState(false);
  const handleBtnClick4 = (): void => {
    setlighbx4(!lighbx4);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose4 = (): void => {
    setlighbx4(!lighbx4);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  const [lighbx5, setlighbx5] = React.useState(false);
  const handleBtnClick5 = (): void => {
    setlighbx5(!lighbx5);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose5 = (): void => {
    setlighbx5(!lighbx5);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  return (
    <div className="container">
      <GlobalStyles />
      <div className="row">
        <div className="col-md-12 text-center">
          <h2>Portfolio</h2>
          <div className="space-border"></div>
        </div>
      </div>
      <Masonry className={"row my-gallery-class"} elementType={"div"}>
        <div
          className="col-lg-4 image-element-class de_modal de_modal"
          onClick={handleBtnClick}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <div className="card-image-1">
            <div className="d-text">
              <h3>Face-Recognition App</h3>
              <a
                href="https://olusegunjoseph.github.io/face-detector/"
                target={"_blank"}
                rel="noreferrer"
              >
                <h5 className="d-tag">website</h5>
              </a>
            </div>
            <img
              src="./img/gallery/facerecognition.png"
              alt="facerecognition app"
            />
          </div>
        </div>

        <div
          className="col-lg-4 image-element-class de_modal"
          onClick={handleBtnClick1}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <div className="card-image-1">
            <div className="d-text">
              <h3>Shopify Ecommerce Store</h3>
              {/* <a href="https://52878d.myshopify.com/">
                <h5 className="d-tag">website</h5>
              </a> */}
            </div>
            <img src="./img/gallery/shopify.png" alt="shopify" />
          </div>
        </div>

        <div
          className="col-lg-4 image-element-class de_modal"
          onClick={handleBtnClick2}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <div className="card-image-1">
            <div className="d-text">
              <h3>Robo-Friends App</h3>
              <a
                href="https://olusegunjoseph.github.io/robo-friends/"
                target={"_blank"}
                rel="noreferrer"
              >
                <h5 className="d-tag">website</h5>
              </a>
            </div>
            <img src="./img/gallery/robofriends.png" alt="robo-friends" />
          </div>
        </div>

        <div
          className="col-lg-4 image-element-class de_modal"
          onClick={handleBtnClick3}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <div className="card-image-1">
            <div className="d-text">
              <h3>Amazon Clone</h3>

              <a
                href="https://challenge-9e6d7.web.app/"
                target={"_blank"}
                rel="noreferrer"
              >
                <h5 className="d-tag">website</h5>
              </a>
            </div>
            <img src="./img/gallery/amazon.png" alt="gallery" />
          </div>
        </div>

        <div
          className="col-lg-4 image-element-class de_modal"
          onClick={handleBtnClick4}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <div className="card-image-1">
            <div className="d-text">
              <h3>Facespace</h3>
              <h5 className="d-tag">website</h5>
            </div>
            <img src="./img/gallery/facespace.png" alt="gallery" />
          </div>
        </div>
        <div
          className="col-lg-4 image-element-class de_modal"
          onClick={handleBtnClick5}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <div className="card-image-1">
            <div className="d-text">
              <h3>Airline-Ticket Reservation Portal</h3>
              <h5 className="d-tag">website</h5>
            </div>
            <img src="./img/gallery/slingair.png" alt="gallery" />
          </div>
        </div>
      </Masonry>

      {/* lightbox1 */}
      {lighbx && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <img
                    src="./img/gallery-big/facerecognition.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Face-Recognition App</h3>
                  <p>
                    This app can detect faces in pictures and it is built with
                    Reactjs, Expressjs, Nodejs and it uses postgres database.
                    Front-end of the app was deployed to github-pages while the
                    backend was deployed to heroku.
                  </p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client:{" "}
                      <span>Personal project</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Web App</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2023</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a
                          href="https://olusegunjoseph.github.io/face-detector/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          olusegunjoseph.github.io/face-detector
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                  {/* <blockquote>
                    "Very well done theme. Versatile, extremely well coded, and
                    gorgeous. That's a great combo. Highly recommended."
                    <span>John Archi</span>
                  </blockquote> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightbox2 */}
      {lighbx1 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose1}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <div className="row g-4">
                    <div className="col-lg-12 item">
                      <img
                        src="./img/gallery-big/shopify.png"
                        alt="galleryimage"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Shopify Store</h3>
                  <p>
                    Shopify ecommerce website for selling of products and
                    services. It is being built with shopify template
                  </p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client: <span>Demo</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Ecommerce Website</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2023</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a
                          href="https://52878d.myshopify.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          www.myshopify.com
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightbox2 */}
      {lighbx2 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose2}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <div className="row g-4">
                    <div className="col-lg-12 item">
                      <img
                        src="./img/gallery-big/robofriends.png"
                        alt="galleryimage"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Robo-Friends API APP</h3>
                  <p>
                    {/* This is a complete replica of amazon using stripe as payment
                    processor. It is being built using tech-stack such as
                    Reactjs,Nodejs,Expressjs and Firebase as database and
                    hosting. */}
                    Front-end application fecthing data from API URL. It is
                    being built with Reactjs,tachions and was deployed to github
                    pages.
                  </p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client: <span>Demo</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Fornt-End App</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2022</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a
                          href="https://olusegunjoseph.github.io/robo-friends"
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://olusegunjoseph.github.io/robo-friends
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightbox3 */}
      {lighbx3 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose3}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <div className="row g-4">
                    <div className="col-lg-12 item">
                      <img
                        src="./img/gallery-big/amazon.png"
                        alt="galleryimage"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Amazon Clone</h3>
                  <p>
                    This is a complete replica of amazon using stripe as payment
                    processor. It is being built using tech-stack such as
                    Reactjs,Nodejs,Expressjs and Firebase as database and
                    hosting.
                  </p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client: <span>Demo</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Full-Stack APP</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2021</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a
                          href="https://challenge-9e6d7.web.app/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://challenge-9e6d7.web.app/
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {lighbx4 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose4}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <div className="row g-4">
                    <div className="col-lg-12 item">
                      <img
                        src="./img/gallery-big/facespace.png"
                        alt="galleryimage"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Facespace</h3>
                  <p>
                    This is one of the projects completed while studying at
                    Concodia University. MERN is the tech stack used for this
                    project such as MondoDB,Expressjs,Reactjs and Nodejs
                  </p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client:{" "}
                      <span>School-Project</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Full-Stack APP</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2022</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a
                          href="https://github.com/OlusegunJoseph/mini-project-facespace"
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://github.com/OlusegunJoseph/mini-project-facespace
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {lighbx5 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose5}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <div className="row g-4">
                    <div className="col-lg-12 item">
                      <img
                        src="./img/gallery-big/slingair.png"
                        alt="galleryimage"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Facespace</h3>
                  <p>
                    This is one of the projects completed while studying at
                    Concodia University. MERN is the tech stack used for this
                    project such as MondoDB,Expressjs,Reactjs and Nodejs
                  </p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client:{" "}
                      <span>Airline-Ticket Reservation Portal</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Full-Stack APP</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2022</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a
                          href="https://github.com/OlusegunJoseph/project-slingair"
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://github.com/OlusegunJoseph/project-slingair
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightboxvideo */}
      {/* {lighbx3 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose3}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row g-5">
                <div className="col-lg-8">
                  <video className="pop" controls autoPlay loop>
                    <source src="./video/local-video-2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="col-lg-8 ">
                  <img
                    src="./img/gallery-big/robofriends.png"
                    alt="galleryimage"
                    className="img-fluid"
                  />
                </div>

                <div className="col-lg-4 de_project-info">
                  <h3>Robo Friends</h3>
                  <p></p>

                  <div className="de_project-details">
                    <div className="d-field">
                      <i className="fa fa-user-o"></i>Client:{" "}
                      <span>Personal Project</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-file-text-o"></i>Type:{" "}
                      <span>Web</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-calendar-o"></i>Year:{" "}
                      <span>2022</span>
                    </div>
                    <div className="d-field">
                      <i className="fa fa-external-link"></i>Preview:{" "}
                      <span>
                        <a href="" target="_blank" rel="noreferrer"></a>
                      </span>
                    </div>
                  </div>
                  <div className="spacer-30"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Gallery;
